module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Communication and Contract Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account Communication Preferences")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountView.toBeContactedAsVolunteer),
      expression: "AccountView.toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountView.toBeContactedAsVolunteer) ? _vm._i(_vm.AccountView.toBeContactedAsVolunteer, null) > -1 : (_vm.AccountView.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountView.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])]), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountView.toReceiveNewsLetter),
      expression: "AccountView.toReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountView.toReceiveNewsLetter) ? _vm._i(_vm.AccountView.toReceiveNewsLetter, null) > -1 : (_vm.AccountView.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountView.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like email updates from OneSight EssilorLuxottica Foundation.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Program Contract")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_c('a', {
    staticClass: "g-font-size-18 just-link",
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" \n            to download a copy of your contract.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-communication-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a72fba0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a72fba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountData/CommunicationInfo.vue
// module id = 534
// module chunks = 4